import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import LoginComp from "@/components/LoginComp";
import LoginPage from "@/pagesv2/LoginPage";

import { Modal } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useHistory } from "react-router-dom";
import Bus from "@/utils/bus";
import { connect } from "dva";
import IconFont from "@/components/icon";
import { FocusSDK, getClientType, getUser } from "@/utils";
export interface LoginDataType {
  type: "path" | "openHomeApp" | "openHomeH5" | "openHomeAI";
  content?: any;
  path?: string;
}
function LoginModal(props: any) {
  const platform = FocusSDK.getDeviceInfo().platform;
  const [visible, setVisible] = useState(false);
  const history = useHistory();
  const { service, focusSDK, authInfo, commonConfig } = useContext<GlobalContextConfig>(GlobalContext);
  const loginData = useRef<LoginDataType | null>(null);
  const loginSuccess = useRef<boolean>(false);
  const showLogin = (data = null) => {
    loginData.current = data;
    setVisible(true);
  };
  const handleClose = () => {
    props.setTouristModePath && props.setTouristModePath({});
    setVisible(false);
    loginSuccess.current = false;
    loginData.current = null;
  };
  useEffect(() => {
    focusSDK.on("showLogin", showLogin);
    return () => {
      focusSDK.off("showLogin", showLogin);
    };
  }, [focusSDK]);
  const onLoginSuccess = useCallback(() => {
    setVisible(false);
    loginSuccess.current = true;
  }, [loginData]);
  useEffect(() => {
    setTimeout(() => {
      if (!loginData.current || !authInfo.userId || !loginSuccess.current) return;
      const { type, content, path } = loginData.current;
      switch (type) {
        case "path":
          path && history.push(path);
          break;
        case "openHomeApp":
          Bus.emit("openHomeApp", content);
          break;
        case "openHomeH5":
          Bus.emit("openHomeH5", content);
          break;
        case "openHomeAI":
          Bus.emit("openHomeAI", content);
          break;
      }
      loginData.current = null;
    }, 20);
  }, [authInfo]);
  useEffect(() => {
    focusSDK.off("loginSuccess", onLoginSuccess).on("loginSuccess", onLoginSuccess);
    return () => {
      focusSDK.off("loginSuccess", onLoginSuccess);
    };
  }, [onLoginSuccess]);

  return (
    <Modal
      visible={visible}
      width="100%"
      // height="100%"
      closable={platform !== "win32"}
      style={{ height: "100vh" }}
      destroyOnClose={true}
      onCancel={handleClose}
      footer={null}
      //   getContainer={() => document.querySelector(".appContent") || document.body}
      wrapClassName="login-modal-wrapper"
    >
      <div>
        {platform === "win32" && (
          <span
            style={{
              display: "inline-block",
              position: "absolute",
              top: "41px",
              left: "10px",
              zIndex: 1,
              width: "72px",
              height: "32px",
              lineHeight: "32px",
              textAlign: "center",
              borderRadius: "16px",
              background: "rgba(0, 0, 0, 0.45)",
              color: "#fff",
              cursor: "pointer"
            }}
            onClick={() => {
              setVisible(false);
            }}
          >
            <IconFont
              style={{ transform: "rotateZ(180deg)", marginRight: "3px" }}
              type="iconjiantou"
            />
            返回
          </span>
        )}
        <LoginPage />
      </div>
    </Modal>
  );
}
function mapStateToProps() {
  return {};
}
function mapDispatchToProps(dispatch: any) {
  return {
    setTouristModePath(data: any) {
      dispatch({ type: "user/setTouristModePath", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
